var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckSquare = function SvgCheckSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.766 2.492a.596.596 0 0 1 0 1.192H4.542a1.386 1.386 0 0 0-1.384 1.384v13.864a1.386 1.386 0 0 0 1.384 1.384h13.864a1.386 1.386 0 0 0 1.384-1.384v-8.263a.596.596 0 0 1 1.192 0v8.263a2.577 2.577 0 0 1-2.576 2.576H4.542a2.577 2.577 0 0 1-2.576-2.576V5.068a2.577 2.577 0 0 1 2.576-2.576zm4.186 1.162a.6.6 0 0 1 .848.848l-9.902 9.902a.6.6 0 0 1-.848 0l-2.97-2.97a.6.6 0 0 1 .847-.849l2.547 2.547z"
  })));
};
export default SvgCheckSquare;